module.exports = __webpack_public_path__ + "img/page_up.b8ba3d97.svg";